import { useQuery } from './query';
import type { PublicConfig } from './types';

/**
 * Public runtime hints (no secrets). Used only to decide whether to show the
 * local demo entry; the server still rejects /api/dev/* outside local demo.
 */
export const PUBLIC_CONFIG_PATH = '/api/config';

export function usePublicConfig() {
  return useQuery<PublicConfig>(PUBLIC_CONFIG_PATH);
}

/** The server decides: dev login needs DEMO_MODE, non-production and a loopback socket. */
export function demoAvailable(config: PublicConfig | undefined): boolean {
  return config?.devLoginAvailable === true;
}
